function deleteAddToCart(data) {
  setTimeout(() => {
    const quickViewContainer = document.querySelector(`[data-product-quickview-handle=${data}]`);
    const ltspTextElement = quickViewContainer.querySelector('.bsscommerce-ltsp-message');
    if (quickViewContainer && ltspTextElement) {
        const quantityElement = quickViewContainer.querySelector('.quantity_selector');
        const addToCartElement = quickViewContainer.querySelector('#bss-add-to-cart');
        if (quantityElement) {
          quantityElement.remove();
        }
        if (quantityElement) {
          addToCartElement.remove();
        }
    }
  }, 1500)
}


const config = { attributes: false, childList: true, subtree: false };
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
        const buttonsQuickView = document.querySelectorAll('button.quickview-icon');
        buttonsQuickView.forEach((button) => {
          const dataProductHandle = button.getAttribute('data-product-handle');
          button.addEventListener("click", () => deleteAddToCart(dataProductHandle))
        })
    }
  }
};

const targetNode1 = document.querySelector('[data-products-to-show].products-grid');
const targetNode2 = document.querySelector('[data-item-to-show].recentlyViewed-row');
const targetNode3 = document.querySelector('#main-collection-product-grid');
const observer = new MutationObserver(callback);

if (targetNode1) {
  observer.observe(targetNode1, config);
}
if (targetNode2) {
  observer.observe(targetNode2, config);
}
if (targetNode3) {
  observer.observe(targetNode3, config);
}



 
